import { defineMessages } from 'react-intl';

export const scope = 'app.commonUtils.capUiLibrary.CapAskAira.AnalyticsBot';

export default defineMessages({
  originalPrompt: {
    id: `${scope}.originalPrompt`,
    defaultMessage: 'Use Original Prompt',
  },
  openingSentence: {
    id: `${scope}.openingSentence`,
    defaultMessage: 'Hey! Can I help you with any data request?',
  },
});
